export const CONFIG_KEYS = {
  hide_language_selector: "hide_language_selector",
  hide_lexile_level: "hide_lexile_level",
  hide_read_aloud: "hide_read_aloud",
  hide_quiz_answers: "hide_quiz_answers",
  disable_vocabulary_support: "disable_vocabulary_support",
  hide_checks_for_understanding: "hide_checks_for_understanding",
  hide_generation_genius_discussion_answers:
    "hide_generation_genius_discussion_answers",
  hide_generation_genius_vocab_definitions:
    "hide_generation_genius_vocab_definitions",
  hide_guided_highlighting: "hide_guided_highlighting",
  hide_translation: "hide_translation",
  show_generation_genius_video_only: "show_generation_genius_video_only",
};
